export const HOTJAR_VERSION = 6;
export const iOS_VERSION = '16.4';
export const ANDROID_VERSION = '8.0';
